import React, { useEffect, useMemo, useState } from 'react';
import MasterService from '../services/master/MasterService';

const KontainerTipe = ({id}) => {
    let masterService = useMemo(() => new MasterService(), [])
    const [tipeKontainer, setTipeKontainer] = useState('')

    useEffect(() => {
        const getTipe = async () => {
            const response = await masterService.getTipeContainerById(id)
            setTipeKontainer(response.data.typeCnt)
        }
        getTipe()
    }, [masterService, id])

    return (
        <>
            {tipeKontainer}
        </>
    )
}

export default KontainerTipe